import { Component, inject, Input, OnInit } from '@angular/core';
import { TeamDetailsService } from '../../team-details.service';
import { ModalController } from '@ionic/angular';
import { SeasonSelectorService } from '../../../../_shared/components/season-selector/season-selector.service';
import { ToastService } from '../../../../_core/services/toast.service';
import { LoaderService } from '../../../../_core/services/loader.service';
import { Router } from '@angular/router';
import { finalize, Subject, takeUntil } from 'rxjs';
import { Season } from '../../../../_shared/models/season.model';
import { Participant, Team } from '../../../../_shared/models/team.model';


@Component({
  selector: 'app-participants-list',
  templateUrl: './participants-list.component.html',
  styleUrls: ['./participants-list.component.scss'],
  standalone: false
})
export class ParticipantsListComponent implements OnInit {

  @Input() teamId!: string;

  isLoading: boolean = true;
  selectedSeason: Season;

  private readonly destroy$: Subject<void> = new Subject();
  removingAdmin: boolean;
  private modalController = inject(ModalController);
  @Input() isOwner: boolean;
  team: Team;
  nonPendingParticipants: Participant[] = [];
  hasPending: boolean;
  pendingCount: number;
  selectedPlayerId?: string;

  constructor(
    private seasonSelectorService: SeasonSelectorService,
    private teamDetailsService: TeamDetailsService,
    private toastService: ToastService,
    private loaderService: LoaderService,
    private router: Router
  ) {
    this.isOwner = this.teamDetailsService.isOwner(this.team?.owners);;
  }

  ngOnInit() {
    const urlSplit = this.router.url.split('/');
    this.teamId = this.teamDetailsService?.teamInfo?._id ?? urlSplit[urlSplit.length - 2];
    this.selectedSeason = this.seasonSelectorService.season;
    this.getTeamParticipants();
    //  this.subscriptions();
  }

  hasPendingRequests() {
    this.hasPending = this.team?.participants?.some(c => c?.person?.claim_status?.toLowerCase() === 'pending') || false;
  }

  getPendingRequestsCount() {
    this.pendingCount = this.team?.participants?.filter(c => c?.person?.claim_status === 'pending').length;
  }

  dismiss() {
    this.modalController.dismiss()
  }

  nonPendingCoaches() {
    this.nonPendingParticipants = this.team?.participants?.filter(c => c?.person?.claim_status?.toLowerCase() !== 'pending' && c?.person?.claim_status?.toLowerCase() !== 'verified') || [];
  }

  claimStaff(userId: string) {
    this.isLoading = true;
    if (this.teamId) {
      this.teamDetailsService
        .claimUserAsStaff(this.teamId, userId, 'player')
        .pipe(
          takeUntil(this.destroy$),
          finalize(() => this.isLoading = false))
        .subscribe({
          next: async (res) => {
            this.isLoading = false;
            this.toastService.presentToast(res?.message);
            this.modalController.dismiss({ success: true });
            this.teamDetailsService.publishUpdateParticipants(true);
          }
        });
    }
  }

  onSelectPlayer(player: any) {
    this.selectedPlayerId = player?.person?._id;
    // Your existing claim logic
    this.claimStaff(player?.person?._id);

    // Automatically close the modal
    this.dismiss();
  }

  getTeamParticipants() {
    this.isLoading = true;
    if (this.teamId) {
      this.teamDetailsService
        .getParticiapnts(this.teamId, this.seasonSelectorService.season?._id, 'player')
        .pipe(
          takeUntil(this.destroy$),
          finalize(() => this.isLoading = false))
        .subscribe({
          next: async (res) => {
            this.isLoading = false;
            this.team = res.data;
            this.isOwner = this.teamDetailsService.isOwner(this.team?.owners);
            this.hasPendingRequests();
            this.getPendingRequestsCount();
            this.nonPendingCoaches();
          }
        });
    }
  }

}